// extracted by css-extract-rspack-plugin
export default {"productSliderSkeletonBorder":"home-fragment__SkeletonTile_productSliderSkeletonBorder__vchs5","w30":"home-fragment__SkeletonTile_w30__auUXf"};